import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

//internal import
import EmployeeLeaveService from "../services/EmployeeLeaveService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useEmployeeLeaveSubmit = (id) => {

  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

  const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [viewData, setviewData] = useState([]);
  const [employeeApproveModal, setEmployeeApproveModal] = useState(false);
  const [employeeRejectModal, setEmployeeRejectModal] = useState(false);


  // add and update employeeLeave details
  const onSubmit = async (data) => {

    setPageLoading(true);

    try {
      const response = id ? await EmployeeLeaveService.UpdateEmployeeLeaveById(id, data) : await EmployeeLeaveService.addEmployeeLeave(data);
      if (response?.success) {
        notifySuccess(response.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response.message);
      }
    } catch (error) {
      console.error(error);
      notifyError("Something went wrong.");
    } finally {
      setPageLoading(false);
    }
  };

  //  delete employeeLeave by id 
  const handleDeleteEmployeeLeave = async (id) => {
    try {
      const response = await EmployeeLeaveService.deleteEmployeeLeaveById(id);
      if (response.success) {
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError("Something want wrong !");
      setIsDeleteModal(false);
    }
  }

  //  approve employeeLeave by id 
  const handleManageEmployeeLeave = async (id, leaveStatus) => {
    try {
      const response = await EmployeeLeaveService.UpdateEmployeeLeaveById(id, { status: leaveStatus });
      if (response.success) {
        if(leaveStatus === "Approved"){
       setEmployeeApproveModal(true);
        }
        else{
          setEmployeeRejectModal(true)
        }
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError("Something want wrong !");
      setIsDeleteModal(false);
    }
  }

  useEffect(() => {
    reset();
    if (id) {
      (async () => {
        try {
          const res = await EmployeeLeaveService.getEmployeeLeaveById(id);
          const data = res?.data;

          if (res?.success) {
            setviewData(data);
            setValue("employeeId", data.employeeId?._id);
            setValue("employeeName", data?.employeeName);
            setValue("reason", data.reason);;
            setValue("leaveFrom", dayjs(data.leaveFrom).format("YYYY-MM-DD"));
            setValue("leaveTo", dayjs(data.leaveTo).format("YYYY-MM-DD"));
            setValue("noOfDays", data.noOfDays);
            setValue("leaveType", data.leaveType);
          }
        } catch (error) {
          console.error("Error fetching employeeLeave data:", error);
        }
      })();
    }
  }, [isModal, id]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    handleDeleteEmployeeLeave,
    handleManageEmployeeLeave,
    pageLoading,
    isModal,
    setIsModal,
    isViewModal,
    setIsViewModal,
    isDeleteModal,
    setIsDeleteModal,
    employeeApproveModal,
    setEmployeeApproveModal,
    employeeRejectModal,
    setEmployeeRejectModal,
    viewData,
  }
}

export default useEmployeeLeaveSubmit;